var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('video',{attrs:{"controls":""},on:{"play":_vm.handlePlay,"pause":_vm.handlePause}},_vm._l((['webm', 'mp4']),function(format){return _c('source',{key:format,attrs:{"src":_vm.getClipPath(format),"type":`video/${format}`}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }